<template>
  <transition @enter="enter" @leave="leave" appear>
    <button
      class="circular-button"
      :class="{ 'circular-button--app' : $inApp, 'circular-button--pause' : $store.state.isGamePlaying }"
      :key="$store.state.isGamePlaying"
      @click="togglePlay"
    >
      <span class="circular-button__bg" />
      <img
        v-if="$store.state.isGamePlaying"
        class="circular-button__icon"
        src="/assets/svg/pause.svg"
        alt="Pause game icon"
        data-icon
      >
      <img
        v-else
        class="circular-button__icon"
        :src="`/assets/svg/${isSoundPlaying ? 'play' : 'pause'}-audio.svg`"
        :alt="isSoundPlaying ? 'Sound playing icon' : 'Sound paused icon'"
        data-icon
      >
    </button>
  </transition>
</template>

<script>
import { initials, enter, leave } from '@/scripts/animations';
import audio from '../scripts/audio';

export default {
  name: 'CircularButton',

  data() {
    return {
      isSoundPlaying: true,
    };
  },

  methods: {
    togglePlay() {
      if (this.$store.state.tutorial >= 0 && this.$store.state.tutorial < 3) return;

      let event;

      audio.play('click');
      if (this.$store.state.isGamePlaying) {
        event = 'play-pause';
      } else {
        this.isSoundPlaying = !this.isSoundPlaying;
        event = this.isSoundPlaying ? 'playGeneralAudio' : 'pauseGeneralAudio';
      }

      this.$eventHub.$emit(event);
    },
    enter(el, done) {
      initials.get('circularButton')(el);
      enter.get('circularButton')(el).then(done);
    },
    leave(el, done) {
      leave.get('circularButton')(el).then(done);
    },
  },
};
</script>

<style lang="scss" scoped>
.circular-button {
  position: absolute;
  top: 20px;
  left: 20px;
  padding: 8px;

  border-radius: 50%;
  cursor: pointer;

  &.circular-button--app {
    top: 52px;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $gold;
    border-radius: 50%;
    box-shadow: $button-shadow;

    @extend %grain;
  }

  &__icon {
    display: block;
    position: relative;
    width: 12px;
  }

  &.circular-button--app {
    padding: 6px;

    .circular-button__icon {
      width: 13px;
    }
  }

  @include mq(ipadP) {
    top: 30px;
    left: 30px;
    padding: 10px;

    &__icon {
      width: 16px;
    }

    &.circular-button--app {
      padding: 8px;

      .circular-button__icon {
        width: 20px;
      }
    }
  }

  @include mq(dm) {
    top: 40px;
    left: 40px;
    padding: 12px;

    &__icon {
      width: 24px;
    }

    &.circular-button--app {
      padding: 10px;

      .circular-button__icon {
        width: 28px;
      }
    }
  }

  @include mq($and: $is-not-touch-device) {
    &__bg {
      transition: transform 0.5s $bloom;
    }
    &:hover &__bg {
      transform: scale(1.1);
    }
  }
}
</style>
